module.exports = __webpack_public_path__ + "03a1d85753b01a00128c4345082c29b3.png";